module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    ref: "swiper",
    staticClass: "swiper-container",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("slide"), _vm._v(" "), _vm._l((_vm.swiperData), function(item, index) {
    return (!!_vm.data) ? _c('div', {
      staticClass: "swiper-slide"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  })], true), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _vm._t("prev"), _vm._v(" "), _vm._t("next"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.showArrow),
      expression: "!!showArrow"
    }],
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.showArrow),
      expression: "!!showArrow"
    }],
    staticClass: "swiper-button-next"
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-02b3b0f8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/swiper.vue
// module id = 292
// module chunks = 2